// extracted by mini-css-extract-plugin
module.exports = {"Image":"CardIcon_Image__3fS6I","ImageBackground":"CardIcon_ImageBackground__4w9j_"};